<template>
  <v-list two-line subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Title</v-list-item-title>
        <v-list-item-subtitle>{{ doc.title }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Description</v-list-item-title>
        <v-list-item-subtitle>{{ doc.description }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Color</v-list-item-title>
        <v-list-item-subtitle>{{ doc.colour }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Users</v-list-item-title>
         <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="item in doc.users" :key="item.name">
                  <td>{{ item.title }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AdminGroupShow",
  data() {
    return {
      doc: {}
    };
  },
  created() {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate (to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
};
</script>
